import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import clsx from 'clsx'
import { useEffect, PropsWithChildren, useState } from 'react'

import { projectsApi } from 'api'
import styles from 'assets/css/main.module.scss'
import { loginRequest } from 'auth/config'
import { Flex } from 'components/common/flex/Flex'
import { Spinner } from 'components/uikit/Spinner/Spinner'

const apiInstances = [projectsApi]

export const ApiProvider = ({ children }: PropsWithChildren<{}>) => {
  const [isReady, setIsReady] = useState(false)
  const { instance, accounts } = useMsal()

  useEffect(() => {
    if (accounts.length === 0) {
      return
    }

    const account = accounts[0]

    const getMsalToken = async () => {
      try {
        const response = await instance.acquireTokenSilent({ ...loginRequest, account })
        return response.accessToken
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          window.location.href = `${process.env.REACT_APP_ROOT_URL}/login`
        }
        return ''
      }
    }

    const interceptors = apiInstances.map(apiInstance => {
      return apiInstance.client.interceptors.request.use(
        async config => {
          const token = await getMsalToken()

          if (token) {
            config.headers.Authorization = `Bearer ${token}`
            config.headers['X-Tenant-Id'] = process.env.REACT_APP_X_TENANT_ID ?? ''
          }

          return config
        },
        error => Promise.reject(error),
      )
    })

    setIsReady(true)

    return () => {
      interceptors.forEach((interceptor, index) => {
        apiInstances[index].client.interceptors.request.eject(interceptor)
      })
    }
  }, [instance, accounts])

  if (!isReady) {
    return (
      <Flex justify="center" align="center" className={clsx(styles.wFull, styles.minHScreen)}>
        <Spinner size="l" data-testid="spinner" />
      </Flex>
    )
  }

  return <>{children}</>
}
